import { JsonDriver } from "./JsonDriver";
import { CsvDriver } from "./CsvDriver";
import { XMLDriver } from "./XMLDriver";

export const dataDrivers = {
	json: JsonDriver,
	csv: CsvDriver
};

export const dataDriversPro = {
	...dataDrivers,
	xml: XMLDriver
};